import { ArchiveIcon } from '@heroicons/react/outline';
import * as React from 'react';
import './Table.scss';
import { useTranslation } from 'react-i18next';

export type TableProps = {
  data?: any;
  columns?: any;
  tableInitialState: {
    tableTotalRecords: number;
    tablePageIndex: number;
  };
  onTableStateChange?: (pageIndex: number) => any;
};

export const QBTable = ({ data, columns, tableInitialState, onTableStateChange }: TableProps) => {
  const tableContainerRef = React.useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const fetchMoreOnBottomReached = (containerRefElement?: HTMLDivElement | null) => {
    if (containerRefElement) {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      if (scrollHeight - scrollTop - clientHeight < 50) {
        getNextSetOfData();
      }
    }
  };

  const getNextSetOfData = () => {
    const totalRecords = data && data.length ? data.length : 0;
    if (totalRecords < tableInitialState.tableTotalRecords) {
      onTableStateChange && onTableStateChange(tableInitialState.tablePageIndex + 1);
    }
  };

  return (
    <div
      className="table-container"
      onScroll={(e) => fetchMoreOnBottomReached(e.target as HTMLDivElement)}
      ref={tableContainerRef}
    >
      {data && data.length ? (
        <table className="petsked-table min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              {columns &&
                columns.map((colData: any, index: number) => (
                  <th
                    key={'qb-record' + index}
                    scope="col"
                    className="px-6 py-3 text-lg font-medium tracking-wider text-left text-gray-500 uppercase"
                  >
                    {colData.ColTitle}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((rowdata: any, entryIndex: number) => (
                <tr key={'qbrowdata-' + entryIndex} className="odd:bg-white">
                  {rowdata.ColData.map((data: any, columnIndex: number) => (
                    <td
                      key={'qbdatacolumn' + columnIndex}
                      className="px-6 py-3 text-lg font-medium text-gray-400 whitespace-nowrap"
                    >
                      {columns[columnIndex].ColType === 'Money' ? `${t('USD')} $` : ''}
                      {data.value}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <>
          <div className="flex flex-col items-center justify-center text-gray-500 bg-white h-80">
            <ArchiveIcon className="w-16 h-16" />
            <h4>
              {window.location.pathname == '/app/reviews' ? t('No Reviews') : t('No Entries Found')}
            </h4>
          </div>
        </>
      )}
    </div>
  );
};
